module.exports = __webpack_public_path__ + "img/smiling.3e789fab.svg";